var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12098 12502)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14047.998 -25778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14065.98,25805.959v0l-4.086-4.084h-5.79v-5.791l-4.105-4.105,4.105-4.1v-5.77h5.771l4.106-4.107,4.1,4.107h5.79v5.783l4.087,4.086-4.087,4.086v5.811h-5.8l-4.086,4.084Zm.262-21.125c-.182,0-.37.008-.515.018a7.191,7.191,0,0,0-4.943,2.455,7.114,7.114,0,0,0-1.753,5.215,7.2,7.2,0,0,0,7.183,6.676c.162,0,.326-.006.518-.02a7.2,7.2,0,0,0,4.947-2.453,7.1,7.1,0,0,0,1.756-5.207A7.224,7.224,0,0,0,14066.242,25784.834Z",
    transform: "translate(-12098 -12498)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.221,
    cy: 5.181,
    rx: 5.221,
    ry: 5.181,
    transform: "translate(1963.007 13288.819)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-12098 -12502)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.305b7fb4.svg";
export { ForwardRef as ReactComponent };